import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  root: {
    display: "flex"
  },
  paper: {
    marginTop: 20,
    padding: theme.spacing(3),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    minWidth:'40%'
  },
  fixedHeight: {
    height: 380
  },
  numberPaper: {
    height: "88%",
    // padding: theme.spacing(2),
    // margin: theme.spacing(2)
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  annotationText: {
    fontSize: 14,
    color: "#afafaf",
    fontWeight: "lighter",
    bottom: 0,
    left: 0
  },
  tituloCards: {
    marginTop: -2,
    textAlign: "right",
    fontSize: 18,
    color: "#333"
  }
}));
